import CandidatesTableViewer from './CandidatesTableViewer'

import { useState, useEffect} from 'react';

function DisplayCandidatesViewer(props) {
    const [colNames, setColNames] = useState([])
    const [colRows, setColRows] = useState([])


    useEffect( () => {  
        if(props.candidates){
            let col_names = [...props.factorNames];
            col_names.push('Strategy');
            setColNames(col_names);
            setColRows(props.candidates);
        }

    }, [props.factorNames, props.candidates] );



    return (<>
            <div style = {{width: `${props.width * 0.91 - 20}px`, marginLeft: '20px', background: 'white', marginTop: '10px', marginBottom: '0px', border:'0.5px solid var(--aixelo-gray-light)'}}>
                <h4 style = {{margin:'0px', marginTop:'10px', marginLeft:'10px', marginBottom:'10px', width:'fit-content'}} >
                            Display Candidates 
                </h4>
                <div style = {{fontSize:'14px', alignItems:'top', margin:'0px', marginLeft:'10px', marginBottom:'5px', height:'fit-content', width:'95%', overflow:'auto'}}>
                    <CandidatesTableViewer 
                        tableRows={colRows}
                        colNames={colNames}
                        itemsPerPage={15}
                        displayPrecision={props.displayPrecision}
                        handleDisplayPrecision={props.handleDisplayPrecision}
                        shiftIdPrecision={0}/>
                </div>
                <div style = {{display:'flex',marginLeft:'10px', marginBottom:'15px', marginTop:'5px'}} >
                    <button className={'actionButtonSmall'} style={{width:'150px', margin:'0px', marginLeft:'0px'}} onClick={props.handleExportTableXLS} >Export Table .xlsx</button>
                    {/* <button className={'actionButtonSmall'} style={{width:'150px', margin:'0px', marginLeft:'0px'}} onClick={props.handleExportTemplateXLS} >Export Template .xlsx</button>    */}
                </div>
            </div>
        </>);

}

export default DisplayCandidatesViewer;